<template>
  <Drawer :title="title" v-model="visible" width="620" class="my-drawer" :mask-closable="false">
    <Form ref="form" :model="formData" :label-width="76" class="page-form less" v-if="visible">
      <h2 class="title">基础信息</h2>
      <!-- <FormItem class="full" v-if="!formData.id && typePerms.length == 2" prop="status" label="新增类型" :label-width="65">
        <RadioGroup v-model="type">
          <Radio label="1">机构</Radio>
          <Radio label="2">团队</Radio>
        </RadioGroup>
      </FormItem> -->
      <template v-if="type == '1' && typePerms.includes('1')">
        <FormItem prop="name" label="机构简称" :rules="$units.formRule.required('请输入', 'blur')" class="full">
          <Input v-model="formData.name" placeholder="请输入" maxlength="16" />
        </FormItem>
        <FormItem prop="type" label="机构类型" :rules="$units.formRule.required('请选择')" key="type">
          <Select v-model="formData.type">
            <Option value="1">个人</Option>
            <Option value="2">企业</Option>
          </Select>
        </FormItem>
        <FormItem label="上级机构">
          <Input v-model="userInfo.organizationName" disabled placeholder="请输入" />
        </FormItem>
        <FormItem :label-width="86" prop="contact" label="联系人姓名" :rules="$units.formRule.required('请输入', 'blur')">
          <Input v-model="formData.contact" placeholder="请输入" />
        </FormItem>
        <FormItem prop="contactMobile" label="联系电话" :rules="oldMobile ? {} : $units.formRule.tel('请输入正确的手机号', false)">
          <Input v-model="formData.contactMobile" placeholder="请输入" @on-change="mobileChange" />
        </FormItem>
        <template v-if="formData.type == '1'">
          <FormItem label="证件类型" prop="idType">
            <lzDicSelect v-model="formData.idType" dicType="USER_CARD_TYPE" :transfer="true" clearable> </lzDicSelect>
          </FormItem>
          <FormItem
            prop="idNo"
            label="证件号"
            :rules="oldIdNo ? {} : $units.formRule.idCard('请输入正确的身份证号', false, 'blur')"
            v-if="formData.idType == '01'"
            key="idNo1"
          >
            <Input v-model="formData.idNo" placeholder="请输入" @on-change="oldIdNo = ''" />
          </FormItem>
          <FormItem prop="idNo" label="证件号" :rules="strLength()" v-else-if="formData.idType == '02'" key="idNo2">
            <Input v-model="formData.idNo" placeholder="请输入" />
          </FormItem>
          <FormItem
            prop="idNo"
            label="证件号"
            :rules="$units.formRule.strLength('请输入正确的通行证件号', 8, false)"
            v-else-if="formData.idType == '16'"
            key="idNo16"
          >
            <Input v-model="formData.idNo" placeholder="请输入" />
          </FormItem>
          <FormItem prop="idNo" label="证件号" v-else-if="formData.idType == '07'" key="idNo7">
            <Input v-model="formData.idNo" placeholder="请输入" />
          </FormItem>
          <FormItem
            prop="idNo"
            label="证件号"
            :rules="$units.formRule.strLength('请输入正确的外国人永久居留证件号', 15, false)"
            v-else-if="formData.idType == '999'"
            key="idNo999"
          >
            <Input v-model="formData.idNo" placeholder="请输入" />
          </FormItem>
          <FormItem prop="idNo" label="证件号" v-else key="-">
            <Input v-model="formData.idNo" placeholder="请输入" />
          </FormItem>
        </template>
        <FormItem :label-width="100" v-if="formData.type == '2'" prop="socialCreditCode" label="公司注册号码">
          <Input v-model="formData.socialCreditCode" placeholder="请输入" />
        </FormItem>
        <FormItem prop="status" label="状态" :label-width="65" :rules="$units.formRule.required('请选择')">
          <i-switch v-model="formData.status" size="large" true-value="1" false-value="0">
            <span slot="open">启用</span>
            <span slot="close">禁用</span>
          </i-switch>
        </FormItem>
        <FormItem prop="sort" label="排序">
          <template slot="label">
            排序
            <Tooltip transfer content="数字越大，顺序越靠前" placement="top">
              <Icon type="md-help-circle" style="color: #a8adb7" />
            </Tooltip>
          </template>
          <Input v-model="formData.sort" placeholder="请输入" />
        </FormItem>

        <FormItem label="所在省市" class="full" prop="city" :rules="$units.formRule.required('请选择')">
          <Select v-model="formData.province" placeholder="省" @on-change="provinceChange" filterable style="width: 50%">
            <Option v-for="(item, i) in regionsArr" :value="item.name" :key="i">{{ item.name }}</Option>
          </Select>
          <Select v-model="formData.city" placeholder="市" filterable style="width: 48%; margin-left: 2%">
            <Option v-for="(item, i) in cityList" :value="item.name" :key="i">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem prop="address" label="地址" key="address" class="full">
          <Input v-model="formData.address" type="textarea" placeholder="最多不超过30个字" maxlength="30" :autosize="{ minRows: 1 }" show-word-limit />
        </FormItem>
        <FormItem label="备注" class="full">
          <Input v-model="formData.remark" type="textarea" placeholder="最多不超过50个字" maxlength="50" :autosize="{ minRows: 3 }" show-word-limit />
        </FormItem>

        <div class="form-title2">账号信息</div>
        <div class="user-form">
          <FormItem prop="account" label="登录账号" :rules="[$units.formRule.required('请输入', 'blur'), $units.formRule.str('不能含有特殊字符和标点符号')]">
            <Input v-model="formData.account" placeholder="请输入" maxlength="20" />
          </FormItem>
          <template v-if="!formData.id">
            <FormItem prop="password" label="登录密码" :rules="$units.formRule.required('请输入', 'blur')">
              <Input v-model="formData.password" placeholder="请输入" style="width: 157px" />
            </FormItem>
            <FormItem prop="password1" label="确认密码" :rules="$units.formRule.required('请输入', 'blur')" class="full">
              <Input v-model="formData.password1" placeholder="请输入" style="width: 157px" />
              <div class="info-text">注:密码8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种，且不能包含账号</div>
            </FormItem>
          </template>
          <template v-else>
            <FormItem prop="password1" label="登录密码">
              <Button type="primary" @click="$emit('editPassword', { id: formData.userId })">修改密码</Button>
            </FormItem>
          </template>
        </div>
      </template>
      <template v-else-if="type == '2' && typePerms.includes('2')">
        <FormItem class="full" prop="name" label="团队名称" :rules="$units.formRule.required('请输入品牌名称', 'blur')">
          <Input v-model="formData.name" placeholder="请输入品牌名称" maxlength="20" />
        </FormItem>
        <FormItem label="所属转介人">
          {{ userInfo.merchantName }}
        </FormItem>
        <FormItem prop="sort" key="sort" label="排序">
          <template slot="label">
            排序
            <Tooltip transfer content="数字越大，顺序越靠前" placement="top">
              <Icon type="md-help-circle" style="color: #a8adb7" />
            </Tooltip>
          </template>
          <Input v-model="formData.sort" placeholder="请输入" />
        </FormItem>
      </template>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="save" :loading="loading">确认</Button>
    </div>
  </Drawer>
</template>

<script>
import lzDicSelect from '@/components/commons/lzDicSelect';
export default {
  components: { lzDicSelect },
  props: {},
  data() {
    return {
      typePerms: ['1', '2'], //新增编辑权限 1机构  2团队
      oldMobile: '',
      type: '2', //新增类型
      visible: false,
      loading: false,
      formData: {},
      userInfo: {},
      curOrg: {}, //当前的节点数据
      regionsArr: [], //区域数据
      cityList: [], //市级数据
      dic: JSON.parse(localStorage.dic),
      oldIdNo: ''
    };
  },
  computed: {
    title() {
      if (this.type == 1) {
        //机构
        return this.formData.id ? '编辑机构' : '新增机构';
      } else {
        // 团队
        return this.formData.id ? '编辑团队' : '新增团队';
      }
    }
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.getRegion(); // 获取省市区域数据
  },
  methods: {
    strLength() {
      return {
        required: false,
        message: '请输入正确的护照号',
        trigger: 'change',
        validator(rule, value) {
          if (!value) return true;
          if (value.length != 8 && value.length != 9) {
            return false;
          }
          return true;
        }
      };
    },
    // 手机号修改
    mobileChange() {
      this.oldMobile = '';
    },
    save() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        if (this.type == 1) {
          if (this.oldMobile == formData.contactMobile) {
            delete formData.contactMobile;
          }
          formData.parentId = this.userInfo.organId;
          if (!this.formData.id) {
            if (formData.password != formData.password1) {
              return this.$notice.error('密码输入不一致');
            }
            const regTeShu = new RegExp("[`_~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？+-]");
            if (regTeShu.test(this.formData.account)) {
              return this.$notice.error('登录账号支持输入数字、字母和汉字');
            }
          }
        } else {
          formData.tenantId = this.curOrg.nodeType * 1 === 0 ? this.curOrg.id : this.curOrg.parentId;
        }
        if (this.oldIdNo == formData.idNo) {
          delete formData.idNo;
        }
        if (this.loading) {
          return;
        }
        this.loading = true;

        let url = '';
        if (this.type == 1) {
          //机构
          url = this.formData.id ? '/buz/organizationBase/edit' : '/buz/organizationBase/add';
        } else {
          // 团队
          url = this.formData.id ? '/buz/groupBase/edit' : '/buz/groupBase/add';
        }

        this.$http({
          type: 'POST',
          url: url,
          data: formData
        })
          .then(res => {
            this.$notice.success('提交成功');
            this.visible = false;
            this.oldMobile = this.formData.mobile;
            this.$emit('success', res.data.id);
          })
          .finally(res => {
            this.loading = false;
          });
      });
    },
    getDetail() {
      this.$http({
        type: 'GET',
        url: this.type == 1 ? '/buz/organizationBase/read/detail' : '/buz/groupBase/read/detail',
        data: { id: this.formData.id }
      }).then(res => {
        this.formData = res.data;
        this.oldMobile = res.data.contactMobile;
        this.oldIdNo = res.data.idNo;
        if (res.data.province) {
          const data = this.regionsArr.find(item => {
            return item.name == res.data.province;
          });
          this.cityList = data.children;
        }
      });
    },
    open(data, isEdit = false) {
      data = JSON.parse(JSON.stringify(data));
      this.type = '2';//1机构、2团队
      this.curOrg = data;
      this.formData = {
        status: '1',
        name: '',
        contact: '',
        idType: '',
        idNo: '',
        contactMobile: '',
        socialCreditCode: '',
        leaderId: '',
        province: '',
        city: '',
        sort: '',
        postcode: '',
        address: '',
        remark: '',
        username: '',
        contactMobile3: '',
        account: '',
        password: ''
      };
      this.oldMobile = '';
      if (isEdit) {
        this.formData.id = data.id;
        this.getDetail();
      }
      // 新增编辑 机构团队权限
      if (isEdit && data.nodeType == 1) {
        this.typePerms = ['1'];
      } else if (isEdit && data.nodeType == 2) {
        this.typePerms = ['2'];
        // this.type = '2';
      } else if (data.nodeType == 2) {
        this.typePerms = [];
      } else if (data.nodeType == 1 && data.isAddOrg == 0) {
        //nodeType1机构、2团队
        //isAddOrg是否能新增机构 1-是 0-否
        this.typePerms = ['2'];
        // this.type = '2';
      } else {
        this.typePerms = ['1', '2'];
      }

      this.visible = true;
    },
    // 获取省市区域数据
    async getRegion() {
      this.regionsArr = await this.$store.dispatch('getRegion');
    },
    // 选择省
    provinceChange(name) {
      this.$set(this.formData, 'city', '');
      const data = this.regionsArr.find(item => {
        return item.name == name;
      });
      this.cityList = data.children;
    },
    verification(password) {
      const capital = /[A-Z]/;
      const regLetter = /[a-z]/;
      const regNum = /[0-9]/;
      const regTeShu = new RegExp("[`_~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？+-]");

      let complex = 0;
      if (capital.test(password)) {
        ++complex;
      }
      if (regLetter.test(password)) {
        ++complex;
      }
      if (regNum.test(password)) {
        ++complex;
      }
      if (regTeShu.test(password)) {
        ++complex;
      }
      if (complex < 3 || password.length < 8 || password.length > 16) {
        this.$notice.error('密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种，且不能包含账号'); //iview中的一个提示框
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import './addOrg.scss';
</style>
